import type { FC } from 'react';
import styles from './index.module.scss';
import Drawer from '@ui/drawer';
import { useToggle } from 'react-use';
import PumpSwap from '@components/pump-swap';
import PumpCompleted from '@components/pump-completed';
import BuyAndSell from '@components/pump-buy-and-sell';
import type { OpenapiClientPump } from 'src/openapi/pump';
import type { PoolFields } from '@libs/pump';
import closeIcon from '@assets/images/icons/close-circle.svg';

const TradeMobile: FC<{
  pool: OpenapiClientPump.GetPoolsByTokenAddressResponse;
  poolFields: PoolFields;
  isBlack: boolean;
}> = ({ pool, poolFields, isBlack }) => {
  const [dialogVisible, toggleDialog] = useToggle(false);
  return (
    <>
      <div className={styles.trade}>
        <div onClick={toggleDialog}>Trade</div>
      </div>

      <Drawer
        open={dialogVisible}
        onClose={toggleDialog}
        placement="bottom"
        className={styles.drawer}
        height={'480px'}
      >
        <div className={styles.drawer_close}>
          <img src={closeIcon} onClick={toggleDialog} />
        </div>
        {pool.is_completed ? (
          pool.clmm_pool_id ? (
            <PumpSwap pool={pool} className={styles.quickly_trade} />
          ) : (
            <PumpCompleted className={styles.quickly_swap} />
          )
        ) : (
          <BuyAndSell
            pool={pool}
            poolFields={poolFields}
            isBlack={isBlack}
            className={styles.quickly_swap}
          />
        )}
      </Drawer>
    </>
  );
};

export default TradeMobile;
